import {
  FETCH_VALIDATE_USER_NAME_REQUEST,
  FETCH_VALIDATE_USER_NAME_SUCCESS,
  FETCH_VALIDATE_USER_NAME_FALUIRE,
  FETCH_CLEAR_VALIDATE_USER_NAME_MESSAGE,
} from './validateUserNameTypes'

const initialState = {
  loading: false,
  isUserNameAvailable: null,
  error: '',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_VALIDATE_USER_NAME_REQUEST : return {
      ...state,
      loading: true,

    }

    case FETCH_VALIDATE_USER_NAME_SUCCESS : return {
      ...state,
      isUserNameAvailable: action.payload,
      error: '',
      loading: false,
    }

    case FETCH_VALIDATE_USER_NAME_FALUIRE : return {
      ...state,
      loading: false,
      isUserNameAvailable: null,
      error: action.payload,
    }
    case FETCH_CLEAR_VALIDATE_USER_NAME_MESSAGE:return {
      ...state,
      loading: false,
      isUserNameAvailable: null,
      error: action.payload,
    }
    default : return state
  }
}

export default reducer
